requestAnimationFrame(() => {
  scriptController.executeWhenScriptLoaded(['modal-opener.js'], () => {
    themeBase.onDOMContentLoadedTrigger(() => {
      if (!customElements.get('navigation-drawer')) {
        class NavigationDrawer extends ModalDialog {
          constructor() {
            super();

            this.mainDetailsToggle = this.querySelector('details');
            this.buttonBack = document.querySelector('.js-menu-drawer-back');
            this.modalOverlay = this.querySelector('.modal-overlay');
            this.menuDrawer = document.querySelector('#menu-drawer');
            this.inner = document.querySelector('.mobile-facets__inner');
            delegate(this, 'click', 'summary', this.onSummaryClick.bind(this));
            delegate(this, 'click', '.js-navigation-drawer-back', this.onCloseButtonClick.bind(this));
          }

          show() {
            super.show(...arguments);
          }

          hide(callback) {

            super.hide(callback);
          }

          onSummaryClick(event) {
            const parentDetails = event.target.closest('details');
            const summaryElement = parentDetails.classList.contains('menu-drawer-container') ? this.querySelector('summary') : parentDetails.querySelector('summary');
            const detailsElement = summaryElement.parentNode;

            const isOpen = detailsElement.hasAttribute('open');
            const reducedMotion = {
              matches: false
            };

            function addTrapFocus() {
              trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
              summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
            }

            if (detailsElement === this.mainDetailsToggle) {
              if (isOpen) event.preventDefault();
              isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
            } else {
              setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
              }, 100);
            }
          }

          openMenuDrawer(summaryElement) {
            if (this.inner) {
              this.inner.removeEventListener('transitionend', this.onCloseTransitionend);
            }

            setTimeout(() => {
              this.mainDetailsToggle.classList.add('menu-opening');
            }, 100);
            summaryElement.setAttribute('aria-expanded', true);
            trapFocus(this.mainDetailsToggle, summaryElement);

            themeBase.freezeScroll({
              breakpoint: this.dataset.breakpoint,
              additionalClass: 'body-menu-opening'
            });
          }

          onCloseTransitionend() {
            document.body.classList.remove('body-menu-opening');
          }

          closeMenuDrawer(event, elementToFocus = false) {
            if (event !== undefined) {
              if (this.inner) {
                this.inner.removeEventListener('transitionend', this.onCloseTransitionend);
                this.inner.addEventListener('transitionend', this.onCloseTransitionend, {
                  once: true
                });
              }

              this.mainDetailsToggle.classList.remove('menu-opening');
              this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
              });
              removeTrapFocus(elementToFocus);
              this.closeAnimation(this.mainDetailsToggle);
            }
            themeBase.unfreezeScroll();
          }

          onCloseButtonClick(event) {
            const detailsElement = event.target.closest('details');
            const summaryElement = detailsElement.querySelector('summary');

            summaryElement.focus();
            this.closeSubmenu(detailsElement);
          }

          closeSubmenu(detailsElement) {
            detailsElement.classList.remove('menu-opening');
            detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
            removeTrapFocus();
            this.closeAnimation(detailsElement);
          }

          closeAnimation(detailsElement) {
            let animationStart;

            const handleAnimation = (time) => {
              if (animationStart === undefined) {
                animationStart = time;
              }

              const elapsedTime = time - animationStart;

              if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
              } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                  trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
              }
            }

            window.requestAnimationFrame(handleAnimation);
          }
        }

        class AccessibleNavigationDrawer extends NavigationDrawer {
            constructor() {
              super();
              this.addEventListener('modalOpened', () => {
                onTransitionEnd(this, () => {
                  if (this.hasAttribute('open') && !this.contains(document.activeElement)) {
                    this.getKeyboardTargets()[0]?.focus({ preventScroll: true });
                  }
                });
              });
              this.addEventListener('modalClosed', () => {
                if (!this.hasAttribute('open') && this.focusReturnTarget?.isConnected) {
                  this.focusReturnTarget.focus({ preventScroll: true });
                  this.focusReturnTarget = null;
                }
              });
              this.addEventListener('keydown', (event) => {
                if (event.key !== 'Tab' || !this.hasAttribute('open')) return;
                const targets = this.getKeyboardTargets();
                const first = targets[0];
                if (!first) return;
                const currentIndex = targets.indexOf(document.activeElement);
                const nextIndex = currentIndex < 0
                  ? (event.shiftKey ? targets.length - 1 : 0)
                  : (currentIndex + (event.shiftKey ? -1 : 1) + targets.length) % targets.length;
                event.preventDefault();
                targets[nextIndex].focus();
              });
            }

            getKeyboardTargets() {
              const activeSubmenu = [...this.querySelectorAll('details[open].menu-opening')].at(-1)?.querySelector(':scope > .menu-drawer__submenu');
              return getFocusableElements(this).filter((element) =>
                element.tabIndex >= 0 && element.getClientRects().length &&
                getComputedStyle(element).visibility !== 'hidden' &&
                (!activeSubmenu || activeSubmenu.contains(element)) &&
                (!element.closest('.menu-drawer__submenu') || element.closest('.menu-drawer__submenu') === activeSubmenu)
              );
            }

            show() {
              if (!this.hasAttribute('open') && !this.contains(document.activeElement)) {
                this.focusReturnTarget = document.activeElement;
              }
              super.show(...arguments);
            }

            hide(callback) {
              this.querySelectorAll('details[open]').forEach((details) => {
                details.classList.remove('menu-opening');
                details.removeAttribute('open');
                details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
              });
              super.hide(callback);
            }

            onSummaryClick(event) {
              const details = event.target.closest('details');
              if (!details) return;
              event.preventDefault();
              if (details.hasAttribute('open')) {
                this.closeSubmenu(details);
                return;
              }
              details.setAttribute('open', '');
              details.querySelector('summary').setAttribute('aria-expanded', 'true');
              requestAnimationFrame(() => {
                if (!this.hasAttribute('open') || !details.hasAttribute('open')) return;
                details.classList.add('menu-opening');
                const submenu = details.querySelector('.menu-drawer__submenu');
                onTransitionEnd(submenu, () => {
                  if (this.hasAttribute('open') && details.classList.contains('menu-opening')) {
                    submenu.querySelector('.js-navigation-drawer-back')?.focus({ preventScroll: true });
                  }
                });
              });
            }

            closeSubmenu(details) {
              details.querySelector('summary').setAttribute('aria-expanded', 'false');
              details.classList.remove('menu-opening');
              onTransitionEnd(details.querySelector('.menu-drawer__submenu'), () => {
                if (!details.classList.contains('menu-opening')) details.removeAttribute('open');
              });
            }
          }


        scriptController.onStyleReady(() => {
          window.NavigationDrawer = NavigationDrawer;
          customElements.define('navigation-drawer', AccessibleNavigationDrawer);
          scriptController.scripts.push('navigation-drawer.js');
        }, ['component-navigation-drawer']);

        if (!customElements.get('facets-drawer')) {
          class FacetsDrawer extends NavigationDrawer {
            constructor() {
              super();
              this.addEventListener('modalOpened', () => {
                onTransitionEnd(this, () => {
                  if (this.hasAttribute('open') && !this.contains(document.activeElement)) {
                    this.getKeyboardTargets()[0]?.focus({ preventScroll: true });
                  }
                });
              });
              this.addEventListener('modalClosed', () => {
                if (!this.hasAttribute('open') && this.focusReturnTarget?.isConnected) {
                  this.focusReturnTarget.focus({ preventScroll: true });
                  this.focusReturnTarget = null;
                }
              });
              this.addEventListener('keydown', (event) => {
                if (event.key !== 'Tab' || !this.hasAttribute('open')) return;
                const targets = this.getKeyboardTargets();
                const first = targets[0];
                const last = targets[targets.length - 1];
                if (!first) return;
                const currentIndex = targets.indexOf(document.activeElement);
                const nextIndex = currentIndex < 0
                  ? (event.shiftKey ? targets.length - 1 : 0)
                  : (currentIndex + (event.shiftKey ? -1 : 1) + targets.length) % targets.length;
                event.preventDefault();
                targets[nextIndex].focus();
              });
            }

            getKeyboardTargets() {
              const activeSubmenu = this.querySelector('.mobile-facets__details[open].menu-opening .mobile-facets__submenu');
              const closeButton = this.querySelector('.js-modal-dialog-close');
              return getFocusableElements(this).filter((element) =>
                element.tabIndex >= 0 && element.getClientRects().length &&
                getComputedStyle(element).visibility !== 'hidden' &&
                (!activeSubmenu || element === closeButton || activeSubmenu.contains(element)) &&
                (!element.closest('.mobile-facets__submenu') || activeSubmenu?.contains(element))
              );
            }

            show() {
              if (!this.hasAttribute('open') && !this.contains(document.activeElement)) {
                this.focusReturnTarget = document.activeElement;
              }
              super.show(...arguments);
            }

            hide(callback) {
              this.querySelectorAll('.mobile-facets__details[open]').forEach((details) => {
                details.classList.remove('menu-opening');
                details.removeAttribute('open');
                details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
              });
              super.hide(callback);
            }

            onSummaryClick(event) {
              const details = event.target.closest('.mobile-facets__details');
              if (!details) return;
              event.preventDefault();
              if (details.hasAttribute('open')) {
                this.closeSubmenu(details);
                return;
              }
              details.setAttribute('open', '');
              details.querySelector('summary').setAttribute('aria-expanded', 'true');
              requestAnimationFrame(() => {
                if (!this.hasAttribute('open') || !details.hasAttribute('open')) return;
                details.classList.add('menu-opening');
                const submenu = details.querySelector('.mobile-facets__submenu');
                onTransitionEnd(submenu, () => {
                  if (this.hasAttribute('open') && details.classList.contains('menu-opening')) {
                    submenu.querySelector('.js-navigation-drawer-back')?.focus({ preventScroll: true });
                  }
                });
              });
            }

            closeSubmenu(details) {
              details.querySelector('summary').setAttribute('aria-expanded', 'false');
              details.classList.remove('menu-opening');
              onTransitionEnd(details.querySelector('.mobile-facets__submenu'), () => {
                if (!details.classList.contains('menu-opening')) details.removeAttribute('open');
              });
            }
          }

          scriptController.onStyleReady(() => {
            customElements.define('facets-drawer', FacetsDrawer);
          }, ['component-facets']);
        }
      }
    });
  });
});